// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"f9dfe1e4","496":"473c7e18","872":"3a67f352","938":"0097d0b1"}[chunkId] + ".chunk.css";
};